
// import {
//   FETCH_ATTENDANCE_REQUEST,
//   FETCH_ATTENDANCE_SUCCESS,
//   FETCH_ATTENDANCE_FAILURE,
//   DELETE_ATTENDANCE_REQUEST,
//   DELETE_ATTENDANCE_SUCCESS,
//   DELETE_ATTENDANCE_FAILURE,
//   FETCH_ATTENDANCE_REPORT_REQUEST,
//   FETCH_ATTENDANCE_REPORT_SUCCESS,
//   FETCH_ATTENDANCE_REPORT_FAILURE,
// } from "../actions/attendanceActions";

// const initialState = {
//   attendance: [],        // for normal daily attendance list
//   attendanceReport: [],  // for attendance report data (summary per employee)
//   pagination: {
//     currentPage: 1,
//     totalPages: 1,
//     totalRecords: 0,
//     limit: 10,
//   },
//   reportPagination: {
//     currentPage: 1,
//     totalPages: 1,
//     totalRecords: 0,
//     limit: 10,
//   },
//   loading: false,
//   error: null,
// };

// const attendanceReducer = (state = initialState, action) => {
//   switch (action.type) {
//     /** ---------------- Normal Attendance ---------------- */
//     case FETCH_ATTENDANCE_REQUEST:
//     case DELETE_ATTENDANCE_REQUEST:
//       return { ...state, loading: true, error: null };

//     case FETCH_ATTENDANCE_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         attendance: action.payload.attendance,
//         pagination: action.payload.pagination,
//       };

//     case DELETE_ATTENDANCE_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         attendance: state.attendance.filter(
//           (item) => item.id !== action.payload
//         ),
//       };

//     case FETCH_ATTENDANCE_FAILURE:
//     case DELETE_ATTENDANCE_FAILURE:
//       return { ...state, loading: false, error: action.payload };

//     /** ---------------- Attendance Report ---------------- */
//     case FETCH_ATTENDANCE_REPORT_REQUEST:
//       return { ...state, loading: true, error: null };

//     case FETCH_ATTENDANCE_REPORT_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         attendanceReport: action.payload.attendance, // API response.data
//         reportPagination: action.payload.pagination, // API response.pagination
//       };

//     case FETCH_ATTENDANCE_REPORT_FAILURE:
//       return { ...state, loading: false, error: action.payload };

//     default:
//       return state;
//   }
// };

// export default attendanceReducer;

import {
  FETCH_ATTENDANCE_REQUEST,
  FETCH_ATTENDANCE_SUCCESS,
  FETCH_ATTENDANCE_FAILURE,
  DELETE_ATTENDANCE_REQUEST,
  DELETE_ATTENDANCE_SUCCESS,
  DELETE_ATTENDANCE_FAILURE,
  FETCH_ATTENDANCE_REPORT_REQUEST,
  FETCH_ATTENDANCE_REPORT_SUCCESS,
  FETCH_ATTENDANCE_REPORT_FAILURE,

  // ✅ NEW ACTION TYPES
  FETCH_EMPLOYEE_DETAILED_ATTENDANCE_REQUEST,
  FETCH_EMPLOYEE_DETAILED_ATTENDANCE_SUCCESS,
  FETCH_EMPLOYEE_DETAILED_ATTENDANCE_FAILURE,
} from "../actions/attendanceActions";

/**
 * =====================================================
 * INITIAL STATE
 * =====================================================
 */
const initialState = {
  /** Daily attendance list */
  attendance: [],

  /** Attendance summary report */
  attendanceReport: [],

  /** ✅ Employee detailed attendance (NEW) */
  employeeDetailedAttendance: [],

  /** Pagination - Daily Attendance */
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    limit: 10,
  },

  /** Pagination - Report */
  reportPagination: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    limit: 10,
  },

  /** ✅ Pagination - Detailed Attendance */
  detailedPagination: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    limit: 10,
  },

  loading: false,
  error: null,
};

/**
 * =====================================================
 * REDUCER
 * =====================================================
 */
const attendanceReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * -------------------------------------------------
     * NORMAL ATTENDANCE
     * -------------------------------------------------
     */
    case FETCH_ATTENDANCE_REQUEST:
    case DELETE_ATTENDANCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        attendance: action.payload.attendance,
        pagination: action.payload.pagination,
      };

    case DELETE_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        attendance: state.attendance.filter(
          (item) => item.id !== action.payload
        ),
      };

    case FETCH_ATTENDANCE_FAILURE:
    case DELETE_ATTENDANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    /**
     * -------------------------------------------------
     * ATTENDANCE REPORT (SUMMARY)
     * -------------------------------------------------
     */
    case FETCH_ATTENDANCE_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ATTENDANCE_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        attendanceReport: action.payload.attendance,
        reportPagination: action.payload.pagination,
      };

    case FETCH_ATTENDANCE_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    /**
     * -------------------------------------------------
     * ✅ EMPLOYEE DETAILED ATTENDANCE (NEW API)
     * -------------------------------------------------
     */
    case FETCH_EMPLOYEE_DETAILED_ATTENDANCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_EMPLOYEE_DETAILED_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeDetailedAttendance: action.payload.attendance,
        detailedPagination: action.payload.pagination,
      };

    case FETCH_EMPLOYEE_DETAILED_ATTENDANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    /**
     * -------------------------------------------------
     * DEFAULT
     * -------------------------------------------------
     */
    default:
      return state;
  }
};

export default attendanceReducer;